/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetUserDynamicPermissionsRequestPermissionsInner
 */
export interface SetUserDynamicPermissionsRequestPermissionsInner {
    /**
     * 
     * @type {string}
     * @memberof SetUserDynamicPermissionsRequestPermissionsInner
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof SetUserDynamicPermissionsRequestPermissionsInner
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the SetUserDynamicPermissionsRequestPermissionsInner interface.
 */
export function instanceOfSetUserDynamicPermissionsRequestPermissionsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function SetUserDynamicPermissionsRequestPermissionsInnerFromJSON(json: any): SetUserDynamicPermissionsRequestPermissionsInner {
    return SetUserDynamicPermissionsRequestPermissionsInnerFromJSONTyped(json, false);
}

export function SetUserDynamicPermissionsRequestPermissionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetUserDynamicPermissionsRequestPermissionsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'enabled': json['enabled'],
    };
}

export function SetUserDynamicPermissionsRequestPermissionsInnerToJSON(value?: SetUserDynamicPermissionsRequestPermissionsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'enabled': value.enabled,
    };
}

